import * as React from 'react';
import { Bev } from './Bev';
import { Spinner } from '../../../components/spinner';
import { Button, Column } from '@codeparva/ui-components-library';
import { BevPageTypes } from '../BevPageTypes';
import { bevLabels, ZOOM_INITIAL_VALUE } from '../constants/generalConstants';
import { navigate } from 'gatsby';
import {
  changeZoomHandler as changeZoomHandlerFn,
  getUnitTypeIdArray,
  getUrl,
} from '../helpers/bevHelpers';
import { BevHeader as BevHeaderComponent } from '../helpers/BevHeaderHelper';
import { HorizontalAndVerticalCardConfig } from '../../locationPage/components/unitAvailability/components/constants/horizontalAndVerticalCardConfig';
import { BevContext } from '../context/bevContext';
import { fetchUnits } from '@codeparva/v11-tfw-api-library';

export const BevParent = ({
  unit_type_id,
  facilityID,
  navigationStateProps,
  floorsList,
  bodyHeight,
  isFacilityMigrated,
  facPublicKey,
}: BevPageTypes.TBevPage) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [unitList, setUnitList] = React.useState<any>();
  const [unitTypesList, setUnitTypesList] = React.useState<any>();
  const [zoomValue, setZoomValue] = React.useState(ZOOM_INITIAL_VALUE);
  const [selectedFloor, setSelectedFloor] = React.useState<string>(
    floorsList[0].id
  );
  const parentRef = React.useRef<HTMLDivElement>(null);
  const [parentDimensions, setParentsDimensions] = React.useState({
    width: 0,
    height: 0,
  });

  const {
    buttons: { autoAllocate, exit },
  } = bevLabels;
  const {
    urls: { moveIn },
  } = HorizontalAndVerticalCardConfig;

  React.useEffect(() => {
    setIsLoading(true);

    (async () => {
      const [
        err,
        {
          data: {
            data: unitData = [],
            relational_data: { unit_type: unitTypeData = [] } = {},
          } = {},
        } = {},
      ] = await fetchUnits({
        size: 10000,
        view: 'tfw_bev',
        termsFilter: {
          bev: {
            level: [selectedFloor],
          },
          status: ['Active'],
        },
        facilityId: facilityID,
        facPublicKey,
      });

      if (err) {
        console.log('Error', err);
        return;
      }

      setUnitList(unitData);
      setUnitTypesList(getUnitTypeIdArray(unitTypeData));
      setIsLoading(false);
      setZoomValue(ZOOM_INITIAL_VALUE);
    })();
  }, [selectedFloor]);

  React.useEffect(() => {
    if (parentRef.current) {
      setParentsDimensions({
        width: parentRef.current.clientWidth,
        height: parentRef.current.clientHeight,
      });
    }
  }, [parentRef, isLoading]);

  const updateFloor = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedFloor(e.target.value);
  };

  const changeZoomHandler = (action: string) => {
    changeZoomHandlerFn(action, zoomValue, setZoomValue);
  };

  const autoAllocateUnit = () => {
    navigate(`${locationName}/${moveIn}`),
      {
        state: {
          ...navigationStateProps,
          bevData: {
            show: false,
            selectedUnitId: '',
          },
        },
      };
  };

  const locationName = getUrl(location.pathname);

  const BevHeader = () => {
    const bevHeaderProps = {
      floorsList,
      selectedFloor,
      updateFloor,
      zoomChangeHandler: changeZoomHandler,
      zoomValue,
      isLoading,
    };

    return <BevHeaderComponent {...bevHeaderProps} />;
  };

  const ButtonsSection = () => (
    <Column paddingless={true} className="btnContainer">
      <Button
        type="button"
        className="exitBtn mr-2"
        onClick={() => {
          navigate(-1);
        }}
      >
        {exit}
      </Button>
      <Button type="button" className="nextBtn" onClick={autoAllocateUnit}>
        {autoAllocate}
      </Button>
    </Column>
  );

  const bevContextValue = {
    height: bodyHeight,
    otherNavigationProps: navigationStateProps,
    nextRoute: `${locationName}/${moveIn}`,
  };

  return (
    <BevContext.Provider value={bevContextValue}>
      <div className="bevContainer">
        <BevHeader />
        <div className="bevCollection" id="bevCollection" ref={parentRef}>
          {isLoading ? (
            <Spinner />
          ) : (
            <div className="parentContainer">
              <Bev
                unit_type_id={unit_type_id}
                unitList={unitList}
                loading={isLoading}
                zoom={zoomValue}
                unitTypesList={unitTypesList}
                parentDimensions={parentDimensions}
                isFacilityMigrated={isFacilityMigrated}
              />
              <ButtonsSection />
            </div>
          )}
        </div>
      </div>
    </BevContext.Provider>
  );
};
